import { Injectable } from '@angular/core';
import { BaseAuthService } from '@stillmandigital/common';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BaseAuthService {
  protected userTokenKey = 'MICHIGAN.USER_TOKEN_KEY';

  public loginUrl = 'login';
}
